<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Configurar precios
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <!-- formulario de precios -->
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__background p-l-10 p-r-10">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail position-relative">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                      <div class="child-left">Nombre tarifa</div>
                      <div class="child-right">
                        {{item.value.description}}
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                      <div class="child-left">Abreviación</div>
                      <div class="child-right">
                        {{item.value.abbreviation}}
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                      <div class="child-left">Fecha inicio</div>
                      <div class="child-right">
                        {{item.value.start_date | date: 'mediumDate'}}
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                      <div class="child-left">Fecha Fin</div>
                      <div class="child-right">
                        {{item.value.end_date | date: 'mediumDate'}}
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                      <div class="child-left">Estado</div>
                      <div class="child-right">
                        <span class="badge badge-success" *ngIf="item.value.is_show">Activo</span>
                        <span class="badge badge-danger" *ngIf="!item.value.is_show">Inactivo</span>
                      </div>
                    </div>

                  </div>
                </div>

                <div class="col-lg-12 m-t-20">
                  <p class="form__group__title f-s-13"> <i class="fas fa-list-alt m-r-3"></i>Tipo de habitaciones</p>
                  <div class="table-responsive">
                    <table class="table mb-0 table-sm table-hover">
                      <thead class="thead-default">
                        <tr>
                          <th class="text-center">¿Habilitado?</th>
                          <th>Tipo Hab.</th>
                          <th class="text-center w-15 position-relative">P.Publicado <span class="required"></span></th>
                          <th class="text-center w-15 position-relative">P.Corporativo <span class="required"></span></th>
                          <th class="text-center w-15">P.Web</th>
                          <th>P.Persona Addi.</th>
                          <th>P.Cama Addi.</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="roomtypes_detail.length == 0">
                          <tr>
                            <td colspan="2"><span>No se encontraron registros</span></td>
                          </tr>
                        </ng-container>
                        <ng-container *ngIf="roomtypes_detail.length > 0">
                          <tr *ngFor="let item of roomtypes_detail; let index_ = index"
                            [ngClass]="{'text-warning': !item.is_active }">
                            <td class="text-center">
                              <div class="input-group justify-content-center">
                                <div class="input-group-prepend input-group-sm">
                                  <div class="custom-control custom-checkbox">
                                    <input id="is_active{{index_}}" type="checkbox" class="custom-control-input"
                                      [checked]="item.is_active" (change)="changeIsActive(index_, $event)" />
                                    <label class="custom-control-label p-t-3" for="is_active{{index_}}"></label>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>{{item.description}}</td>
                            <td class="text-center w-15">
                              <div class="input-group">
                                <div class="input-group-prepend"><span
                                    class="input-group-text f-s-12">{{toolsService.momeySol()}}</span>
                                </div>
                                <input type="text" id="price_public{{index_}}"
                                  class="form-control form-control-xs text-center" value="{{item.price_public}}"
                                  (keyup)="changePricePublic($event.target, index_)" numeric decimals="2"
                                  onclick="click_input(this)">
                              </div>
                            </td>
                            <td class="text-center w-15">
                              <div class="input-group">
                                <div class="input-group-prepend"><span
                                    class="input-group-text f-s-12">{{toolsService.momeySol()}}</span>
                                </div>
                                <input type="text" id="price_corporate{{index_}}"
                                  class="form-control form-control-xs text-center" value="{{item.price_corporate}}"
                                  (keyup)="changePriceCorporate($event.target, index_)" numeric decimals="2"
                                  onclick="click_input(this)">
                              </div>
                            </td>
                            <td class="text-center w-15">
                              <div class="input-group">
                                <div class="input-group-prepend"><span
                                    class="input-group-text f-s-12">{{toolsService.momeySol()}}</span>
                                </div>
                                <input type="text" id="price_web{{index_}}"
                                  class="form-control form-control-xs text-center" value="{{item.price_web}}"
                                  (keyup)="changePriceWeb($event.target, index_)" numeric decimals="2"
                                  onclick="click_input(this)">
                              </div>
                            </td>
                            <td>
                              <div class="input-group">
                                <div class="input-group-prepend"><span
                                    class="input-group-text f-s-12">{{toolsService.momeySol()}}</span>
                                </div>
                                <input type="text" id="price_person_additional{{index_}}"
                                  class="form-control form-control-xs text-center"
                                  value="{{item.price_person_additional}}"
                                  (keyup)="changePricePersonAdditional($event.target, index_)" numeric decimals="2"
                                  onclick="click_input(this)">
                              </div>
                            </td>
                            <td>
                              <div class="input-group">
                                <div class="input-group-prepend"><span
                                    class="input-group-text f-s-12">{{toolsService.momeySol()}}</span>
                                </div>
                                <input type="text" id="price_bed_additional{{index_}}"
                                  class="form-control form-control-xs text-center"
                                  value="{{item.price_bed_additional}}"
                                  (keyup)="changePriceBedAdditional($event.target, index_)" numeric decimals="2"
                                  onclick="click_input(this)">
                              </div>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>

            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
